import { render, staticRenderFns } from "./MatrizValores.vue?vue&type=template&id=53c4ed7a"
import script from "./MatrizValores.vue?vue&type=script&lang=js"
export * from "./MatrizValores.vue?vue&type=script&lang=js"
import style0 from "./MatrizValores.vue?vue&type=style&index=0&id=53c4ed7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports